import createIsDirty from './selectors/isDirty';
import plain from './structure/plain';

export default createIsDirty(plain);


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/redux-form/es/isDirty.js
// module id = 1226
// module chunks = 4